import React from 'react';
import { Card, CardContent, CardActionArea, Typography, IconButton, Grid } from '@mui/material';
import Container from '@mui/material/Container';
import { useThemeClientLogo } from '../contexts/Theme.js';

const Logo = ({ style }) => {
    const { logo } = useThemeClientLogo();

    return (
        <Container component="main" maxWidth="xs" sx={{ marginTop: 2 }}>
            <img src={logo} style={{ ...style }} />
        </Container>
    )
}

export default Logo;